import { NativeSelect, Text } from "@chakra-ui/react";
import type * as React from "react";
import { useShopContext } from "../shop";

export const ShopSelector: React.FC = () => {
  const { shops, currentShopId, setCurrentShopId } = useShopContext();

  if (shops.length === 0) {
    return null;
  }
  if (shops.length === 1) {
    return <Text>{shops[0].name}</Text>;
  }

  const handleShopChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const shopId = event.target.value;
    if (shopId) {
      setCurrentShopId(shopId);
    }
  };

  return (
    <NativeSelect.Root width="auto" disabled={shops.length <= 1}>
      <NativeSelect.Field value={currentShopId || ""} onChange={handleShopChange}>
        {shops.map((shop) => (
          <option key={shop.id} value={shop.id}>
            {shop.name}
          </option>
        ))}
      </NativeSelect.Field>
      <NativeSelect.Indicator />
    </NativeSelect.Root>
  );
};
